import {useAppContext} from "./useAppContext";
import {useRefsContext} from "../utils/refContext";
import {useProductRating} from "./useProductRating";
import {useAppDispatch} from "../redux/stateHooks";
import {openAccordionItemIfClosed} from "../redux/slices/accordion";
import {AccordionItemType} from "../definitions/enums";

export const useLeftColumnModel = () => {
    const dispatch = useAppDispatch();
    const {title} = useAppContext();
    const {ratingsAccordionItemRef} = useRefsContext();
    const {count, grade} = useProductRating();
    return {
        title,
        ratingStatistics: {
            count,
            grade,
            onClick: () => {
                dispatch(openAccordionItemIfClosed(AccordionItemType.Reviews));
                return ratingsAccordionItemRef.current?.scrollIntoView({behavior: "smooth"});
            }
        }
    }
}